export default __webpack_public_path__ + "static/media/developer-icon.e5913797.png";